import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "promocode-button",
  "use": "promocode-button-usage",
  "viewBox": "0 0 33 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 28\" id=\"promocode-button\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-width=\"4\" d=\"M94.124 29.97L105.435 39.576 122.124 17.576\" transform=\"translate(-92 -15)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol